module.exports = __webpack_public_path__ + "static/3-a276d2b979485832749e100ac6163e85.png";